import { render } from "./ViewHeader.vue?vue&type=template&id=33b83d7d&scoped=true"
import script from "./ViewHeader.vue?vue&type=script&lang=js"
export * from "./ViewHeader.vue?vue&type=script&lang=js"

import "./ViewHeader.vue?vue&type=style&index=0&id=33b83d7d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Raska\\Desktop\\raska\\projekat\\astra\\astra-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b83d7d"]])

export default __exports__